import router from "_private/router";
import permission from "_private/config/permission";

permission(router);
